import React from 'react'
import './web.css'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faBriefcase, faLaptop, faPenToSquare, faUser } from '@fortawesome/free-solid-svg-icons'

function Web() {
  return (
    <div className="web">
       <div className="web-option">
        <a href="#project">
        <FontAwesomeIcon icon={faPenToSquare} className='option-icon' />Project
        </a>
       </div>
       <div className="web-option">
        <a href="#skill">
        <FontAwesomeIcon icon={faLaptop} className='option-icon'  />Skills
        </a>
       </div>
       <div className="web-option">
        <a href="#work">
        <FontAwesomeIcon icon={faBriefcase} className='option-icon' />Works
        </a>
       </div>
       <div className="web-option">
        <a href="#contact">
        <FontAwesomeIcon icon={faUser} className='option-icon' />Contact
        </a>
       </div>
    </div>
  )
}

export default Web